import React, {Component} from 'react';
import {graphql} from 'react-apollo';
import userQuery from 'graphql/queries/user.gql';
import SectionTitle from 'components/section-title';
import KeyValueList from 'components/key-value-list';
import SuccessMessage from 'components/success-message';
import Spinner from 'components/spinner';
import Button from 'components/button';
import styles from './styles.css';

@graphql(userQuery)
export default class Profile extends Component {
    render() {
        if (this.props.data.loading) return <Spinner />;

        const {user} = this.props.data;
        const {state} = this.props.history.location;
        const message = state && state.message;

        return (
            <div className={styles.root}>
                <div>
                    <SectionTitle title='Datos del usuario' />
                    <KeyValueList
                        data={user}
                        rows={[
                            {key: 'firstName', label: 'Nombre'},
                            {key: 'lastName', label: 'Apellido'},
                            {key: 'email', label: 'Email'},
                            {key: 'category.name', label: 'Tipo de usuario'},
                            {label: 'Notificaciones', value: user.receiveOrganizationEmails ? 'Sí' : 'No'},
                        ]}
                    />
                    <div className={styles.actions}>
                        <a target='_blank' href={`${window.SSO_UI_URL}/profile`}>
                            <Button theme='yellow'>
                                EDITAR PERFIL
                            </Button>
                        </a>
                        <a target='_blank' href={`${window.SSO_UI_URL}/password/change`}>
                            <Button theme='yellow'>
                                CAMBIAR CONTRASEÑA
                            </Button>
                        </a>
                    </div>
                    {message && <SuccessMessage message={message} removeAfter={5000} />}
                </div>
                <div>
                    <SectionTitle title='Datos de la organización' />
                    <KeyValueList
                        data={user.organization}
                        rows={[
                            {key: 'name', label: 'Nombre'},
                            {key: 'legalName', label: 'Razón social'},
                            {key: 'cuit', label: 'CUIT'},
                            (user.organization.region && {key: 'region.name', label: 'Región Nidera'}),
                        ]}
                    />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./views/users/profile/index.js